import { PrivateAccessType } from '../../../../../interfaces/interfaces';
import { POLICY_MANAGER, PolicyManagerType } from '../../../firewallsUtil';

export const DOCUMENTATION_URLS = {
  USER_ID_AGENT: 'https://docs.paloaltonetworks.com/ngfw/help/11-2/device/device-data-redistribution/device-data-redistribution-agents',
  RESOURCE_GATEWAY: 'https://docs.aws.amazon.com/vpc/latest/privatelink/create-resource-gateway.html',
  LDAP: 'https://docs.paloaltonetworks.com/ngfw/help/11-2/device/device-server-profiles-ldap',
  DNS: 'https://docs.paloaltonetworks.com/ngfw/networking/dns/configure-a-dns-proxy-object',
  AWS_RESOURCE_GATEWAY_OVERVIEW: 'https://docs.aws.amazon.com/vpc/latest/privatelink/resource-gateway.html',
} as const;

export const PRIVATE_ACCESS_CONFIG = {
  Firewall: ['FirewallId', 'Region', 'PvtAccess', 'UpdateToken', 'DeploymentUpdateToken'],
  Status: ['PvtAccessStatus'],
} as const;

// Panorama-managed firewalls support User-ID and LDAP; SCM (Strata)-managed firewalls support DNS.
export const getResourceTypeOptions = (translate: (key: string) => string, policyManager?: PolicyManagerType): Array<{ children: string; value: PrivateAccessType }> => {
  if (policyManager === POLICY_MANAGER.STRATA) {
    return [
      {
        children: translate('resources.firewallsV2.privateAccess.dnsResolver'),
        value: 'DNS',
      },
    ];
  }

  return [
    {
      children: translate('resources.firewallsV2.privateAccess.userIdRedistributionAgent'),
      value: 'USERID',
    },
    {
      children: translate('resources.firewallsV2.privateAccess.lDAPProfile'),
      value: 'LDAP',
    },
  ];
};
